import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import Button from "../../button";
import StatusDropdown from "../../dropdown/StatusDropDown";
import { useGetAllUserStatusesQuery } from "../../../store/admin/userStatuses";

const AssignAreaCodeModal = ({
  isOpen,
  handleClose,
  handleInputChange,
  text,
  loader,
  status,
  setSelectedOption,
  selectedOption,
  handleOptionClick,
  professionalAreaCode,
  handleAssignPhoneNumberWithCode,
}) => {
  const { data: allUserStatuses } = useGetAllUserStatusesQuery();
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform rounded-[10px] bg-white p-6 text-left shadow-xl transition-all sm:my-8 w-full max-w-[480px]">
                <div>
                  <div className="mb-5 flex items-center justify-between gap-5 pb-2 border-b border-solid border-[#485868]">
                    <Dialog.Title
                      as="h3"
                      className="text-[17px] sm:text-[22px] leading-[160%] font-semibold text-customGray"
                    >
                      Confirmation
                    </Dialog.Title>
                    <XMarkIcon
                      className="w-5 sm:w-6 h-5 sm:h-6 cursor-pointer hover:text-red-500"
                      aria-hidden="true"
                      onClick={handleClose}
                    />
                  </div>
                </div>
                <div className="pt-2">
                  <h6 className="text-sm md:text-base font-medium leading-[160%] text-customGray mb-6">
                    {text}
                  </h6>
                </div>
                <div className="mb-5">
                  <div
                    className={`h-10 rounded-md border border-[#EBEFF3] bg-[#F1F4F6] flex items-center justify-center`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <input
                      type="text"
                      value={professionalAreaCode}
                      placeholder="Area Code"
                      pattern="/^[0-9]+$/"
                      onKeyPress={(event) => {
                        const regex = /^[0-9]+$/;
                        const key = String.fromCharCode(
                          !event.charCode ? event.which : event.charCode
                        );
                        if (!regex.test(key)) {
                        event.preventDefault();
                        }
                      }}
                      onPaste={(e) => e.preventDefault()}
                      inputMode="numeric"
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => handleInputChange(e.target.value)}
                      className="bg-transparent text-sm font-normal leading-[140px] text-customGray border-l border-[#EBEFF3] pl-2.5 h-5"
                    />
                  </div>
                </div>
                <div className="flex items-center justify-center gap-5 max-w-[180px] md:max-w-[200px] ml-auto w-full">
                  <Button
                    title="Yes"
                    type="button"
                    classes="bg-primary w-full h-10 flex justify-center items-center text-sm md:text-base font-black leading-[160%] rounded-md text-white duration-500"
                    onClick={handleAssignPhoneNumberWithCode}
                    buttonLoader={loader && loader}
                  >
                    Yes
                  </Button>
                  <Button
                    title="No"
                    type="button"
                    classes="bg-red-500 w-full h-10 flex justify-center items-center text-sm md:text-base font-black leading-[160%] rounded-md text-white duration-500"
                    onClick={handleClose}
                  >
                    No
                  </Button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default AssignAreaCodeModal;
